/* affiliates-join.js — /join.html only (R2031 R020 + R089). (1) The "your link" stage for ?intent=affiliate|both: the link types
   itself, the commission tiles count up one after another (sample figures, labelled SAMPLE), the ladder lights Builder when the
   first one lands; it runs only while the stage is on screen, never under reduced motion, Save-Data or in a hidden tab — the HTML is
   the final frame. (2) "Have a code?": checked by the same route as the plan panes (window.clozoCoupon.apply = coupon.js), stored
   the same way, so it rides on the first checkout. Text nodes only. */
(function () {
'use strict';
var D = document, H = D.documentElement;
function $(id) { return D.getElementById(id); }
function rm() { try { return matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; } }
function cents(s) { var m = /([0-9][0-9,]*\.[0-9]{2})/.exec(s || ''); return m ? Math.round(parseFloat(m[1].replace(/,/g, '')) * 100) : 0; }
function money(c) { return '+US$' + (c / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }

/* ---- (1) the stage ---- */
function stage() {
  var hero = $('join-hero');
  if (!hero || rm() || (navigator.connection && navigator.connection.saveData)) return;
  if (!/^(affiliate|both)$/.test(H.getAttribute('data-intent') || '')) return;
  var url = hero.querySelector('[data-jh-type]'), full = url.getAttribute('data-jh-type'), base = full.slice(0, full.indexOf('?via=') + 5);
  var tiles = [].slice.call(hero.querySelectorAll('.aff-jh-tile')), line = hero.querySelector('.aff-jh-line i'), rungs = hero.querySelectorAll('.aff-jh-ladder li:not(.aff-jh-line)');
  var timers = [], on = false, seen = false, loopT = 0;
  tiles.forEach(function (t) { var b = t.querySelector('b'); b.setAttribute('data-c', cents(b.textContent)); });
  function later(ms, fn) { timers.push(setTimeout(fn, ms)); }
  function stop() { timers.forEach(clearTimeout); timers = []; on = false; }
  function count(b, to) {
    var t0 = 0;
    requestAnimationFrame(function step(ts) {
      if (!on) { b.textContent = money(to); return; }
      t0 = t0 || ts; var k = Math.min(1, (ts - t0) / 650);
      b.textContent = money(Math.round(to * (1 - Math.pow(1 - k, 3))));
      if (k < 1) requestAnimationFrame(step);
    });
  }
  function rung(n) { [].forEach.call(rungs, function (r, i) { r.classList.toggle('is-on', i <= n); }); if (line) line.style.setProperty('--k', n === 0 ? 0.25 : 0.25 + n * 0.2); }
  function run() {
    if (on) return; on = true;
    var i = 0, typed = base.length;
    url.textContent = base; url.classList.add('is-typing');
    tiles.forEach(function (t) { t.querySelector('b').textContent = money(0); t.classList.remove('is-hot'); });
    rung(0);
    (function type() { if (!on) return; if (typed < full.length) { url.textContent = full.slice(0, ++typed); later(70, type); } else { url.classList.remove('is-typing'); later(350, tile); } })();
    function tile() {
      if (!on || i >= tiles.length) { if (on) later(4200, again); return; }
      var t = tiles[i++], b = t.querySelector('b');
      if (t.offsetParent === null) return tile();   // the phone hides the 4th tile
      t.classList.add('is-hot'); count(b, +b.getAttribute('data-c'));
      if (i === 1) later(500, function () { rung(1); });
      later(900, function () { t.classList.remove('is-hot'); tile(); });
    }
  }
  function again() { on = false; if (seen && !D.hidden) loopT = setTimeout(run, 600); }
  function finish() { stop(); clearTimeout(loopT); url.classList.remove('is-typing'); url.textContent = full; tiles.forEach(function (t) { var b = t.querySelector('b'); b.textContent = money(+b.getAttribute('data-c')); t.classList.remove('is-hot'); }); rung(1); }
  if (!window.IntersectionObserver) return;
  new IntersectionObserver(function (es) {
    seen = es[0].isIntersecting;
    if (seen && !on && !D.hidden) run(); else if (!seen) finish();
  }, { threshold: 0.35 }).observe(hero);
  D.addEventListener('visibilitychange', function () { if (D.hidden) finish(); else if (seen) run(); });
}

/* ---- (2) "Have a code?" ---- */
function code() {
  var box = $('jc-box'), tg = $('jc-toggle'), inp = $('jc-input'), ap = $('jc-apply'), msg = $('jc-msg'), saved = D.querySelector('[data-coupon-join]');
  if (!box || !tg) return;
  function say(t) { msg.textContent = t || ''; if (t) inp.setAttribute('aria-invalid', 'true'); else inp.removeAttribute('aria-invalid'); }
  tg.addEventListener('click', function () { var o = box.hidden; box.hidden = !o; tg.setAttribute('aria-expanded', String(o)); if (o) inp.focus(); });
  function go() {
    var c = inp.value.trim(), lab = ap.querySelector('.btn-label');
    if (!/^[A-Za-z0-9_-]{2,32}$/.test(c)) { say('A code is 2 to 32 letters, digits, dashes or underscores.'); return inp.focus(); }
    if (!window.clozoCoupon || !clozoCoupon.apply) { say('We couldn’t check the code. Try again in a moment.'); return; }
    say(''); ap.disabled = true; lab.textContent = 'Checking…';
    clozoCoupon.apply(c).then(function (res) {
      ap.disabled = false; lab.textContent = 'Apply';
      if (!res || !res.valid) { say((res && res.message) || 'That code isn’t one we know.'); return inp.focus(); }
      var p = String((res.percentBps || 0) / 100);
      if (saved) { saved.textContent = 'Code ' + String(res.code).toUpperCase() + ' saved for your first plan: ' + p + '% off your first month or year.'; saved.hidden = false; }
      box.hidden = true; tg.setAttribute('aria-expanded', 'false'); tg.textContent = 'Use a different code';
    }, function (err) {
      ap.disabled = false; lab.textContent = 'Apply';
      say(err && err.status === 429 ? 'Too many tries from this connection. Wait a minute and try again.' : 'We couldn’t check the code. Try again in a moment.');
    });
  }
  ap.addEventListener('click', go);
  inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); go(); } });
}

function boot() {
  try { code(); } catch (e) {}
  var once = false;
  function start() { if (once) return; once = true; try { stage(); } catch (e) {} }
  /* after the /site-config swap of the [data-off] figures (affiliates-auth.js registers it first): site-runtime.js is a LATER
     deferred script, so wait for DOMContentLoaded when it is not defined yet (E2E-01) */
  function cfg() { try { if (window.__clozoRuntime) __clozoRuntime.config(start); else start(); } catch (e) { start(); } }
  if (window.__clozoRuntime) cfg(); else D.addEventListener('DOMContentLoaded', cfg);
}
if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', boot); else boot();
})();
